import { Typography } from '@mui/material'
import styled from 'styled-components'
import { COLORS } from '~theme/colors'

import { Colors } from '~theme/deprecated-vt/deprecated-vt-theme'

export const StyledDropzone = styled.div<{
  isDragActive: boolean
  style?: React.CSSProperties
}>`
  position: relative;
  display: flex;
  align-items: center;
  height: 140px;
  border-style: dashed;
  border-color: ${Colors.greys.dark};
  border-width: 1px;
  border-radius: 6px;
  background-color: ${(props) => {
    return props.isDragActive ? Colors.greys.lightest : 'transparent'
  }};
  width: ${(props) => (props.style?.width ? props.style.width : '464px')};

  &:focus {
    outline: none;
  }

  &:hover {
    cursor: pointer;
  }
`

export const FileBoxText = styled(Typography)<{ color?: string }>`
  color: ${({ color }) => (color ? color : COLORS.secondary.midBlue)};
`
